import { OnboardingStep } from 'types/onboardingTypes'

export function getHappyWeightInfo(): OnboardingStep {
  return {
    id: 'happy_weight_info',
    type: 'custom'
  }
}
